export enum EStatusTypes {
  STATUS_SUCCESS = 'success',
  STATUS_WARNING = 'warning',
  STATUS_DANGER = 'danger',
  STATUS_IN_PROGRESS = 'inProgress',
  STATUS_NOT_STARTED = 'notStarted',
}
